import { publicApiClient } from '@/lib/api/client';
import type { LoginRequest, LoginResponse } from '@/features/user/types/types';

export const loginService = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const response = await publicApiClient.post<LoginResponse>(
      '/api/public/v1/public-user/login',
      credentials
    );
    return response;
  },
};
